﻿export default class TmkGlobalUpdate {

    controllerUrl = "";
    refreshLog = true;
    criteriaUpdated = false;

    caseNumberSearchValueMapper(options) {
        const url = $("#updateCriteriaForm").data("case-number-mapper-url");
        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    getCriteria() {
        const form = $("#updateCriteriaForm");
        const data = pageHelper.formDataToJson(form, false);

        const updateField = $("#UpdateField_tmkGlobalUpdate").data('kendoComboBox').value();
        const dataFrom = $("#FromData_tmkGlobalUpdate").data('kendoComboBox').value();
        const dataTo = $("#ToData_tmkGlobalUpdate").data('kendoComboBox').value();
        data.payLoad["UpdateField"] = updateField;
        data.payLoad["DataFrom"] = dataFrom;
        data.payLoad["DataTo"] = dataTo;

        const multiselect = $("#TrademarkStatuses").data("kendoMultiSelect");
        const items = multiselect.value();
        let tmkStatuses = "";        

        for (var i = 0; i < items.length; i++) {
            tmkStatuses += "|" + items[i] + "|";
        }

        data.payLoad["TrademarkStatuses"] = tmkStatuses;

        return data.payLoad;
    }

    getUpdateField() {
        return $("#UpdateField_tmkGlobalUpdate").data('kendoComboBox').value();
    }

    getUpdateFieldFromParam = () => {
        var fromDataVal = $("#FromData_tmkGlobalUpdate").data('kendoComboBox').text();       
        return { updateField: this.getUpdateField(), fieldValue: fromDataVal };
    }

    getUpdateFieldToParam = () => {
        var toDataVal = $("#ToData_tmkGlobalUpdate").data('kendoComboBox').text();
        return { updateField: this.getUpdateField(), fieldValue: toDataVal };
    }

    configurePreviewRows=()=> {
        const updateField = this.getUpdateField();        
        let isActionLevel = false;
        if (updateField === "RespAtty") isActionLevel = true;  

        if (isActionLevel) {
            $(".updateActionBlock").show();
        } else {
            $(".updateActionBlock").hide();
        }        
    }

    refreshUpdatePreview = function () {
        
        if (this.criteriaUpdated) {
            // if no update field and data from, 
            if ($("#UpdateField_tmkGlobalUpdate").data('kendoComboBox').value() === "" ||
                $("#FromData_tmkGlobalUpdate").data('kendoComboBox').value() === "") {
                $('#previewListView').data('kendoListView').dataSource.data([]);
                return;
            }
            const listView = $('#previewListView').data('kendoListView');
            listView.dataSource.read();
            listView.dataSource.page(1);

            this.criteriaUpdated = false;
        }
    }

    // no need to trap this event, the fromDataChange kicks off before this (and takes care of the refresh)
    //this.updateFieldChange = function (e) {
    //    alert("updateFieldChange");
    //    $('#previewListView').data('kendoListView').dataSource.data([]);
    //}

    fromDataChange = (e)=> {
        const tab = $('#update-tab .nav-link.active').attr('id');
        this.criteriaUpdated = true;
        if (tab === "Records-tab") {
            this.refreshUpdatePreview();
        }
    }

    bindEvents = () => {
        const self = this;

        // tab change
        $('#update-tab a').on('click', (e)=> {
            const tab = e.target.id;
            switch (tab) {
                case "Records-tab":
                    this.refreshUpdatePreview();
                    break;
                case "Log-tab":
                    if (this.refreshLog) {
                        const logGrid = $('#updateLog').data('kendoGrid');
                        logGrid.dataSource.read();
                        this.refreshLog = false;
                    }
                    break;
            }
        });

        $("#UpdateField_tmkGlobalUpdate").change((e)=> {
            const chkComboFields = "CaseNumber-Agent-Attorney1-Attorney2-Attorney3-Client-Owner";
            const updateField = $("#UpdateField_tmkGlobalUpdate").data('kendoComboBox').value();
            let prevDisabledElt = $("#prevDisabledElt").val();               // use for disabling criteria fields (disable if = data to update)
            const screen = "tmkGlobalUpdate";

            //alert(prevDisabledElt);
            //alert(updateField);

            if (prevDisabledElt !== "") {
                // enable previously disable combo box
                if (chkComboFields.search(prevDisabledElt) > -1) {
                    enableComboBox(`#${prevDisabledElt}_${screen}`, true);
                    enableComboBox(`#${prevDisabledElt}Name_${screen}`, true);
                }
                else if (prevDisabledElt === "TrademarkStatus") {
                    enableTmkStatus(true);
                }
                // clear
                prevDisabledElt = "";
            }

            // check if we need to disable criteria field = updatefield
            if (chkComboFields.search(updateField) > -1) {
                prevDisabledElt = updateField;
                enableComboBox(`#${prevDisabledElt}_${screen}`, false);
                enableComboBox(`#${prevDisabledElt}Name_${screen}`, false);
            }
            else if (updateField === "TrademarkStatus") {
                enableTmkStatus(false);
                prevDisabledElt = updateField;
            }

            $("#prevDisabledElt").val(prevDisabledElt);

            function enableComboBox(comboName, enable) {
                const comboBox = $(comboName).data("kendoComboBox");
                comboBox.enable(enable);
            }

            function enableTmkStatus(enable) {
                const multiSelect = $("#TrademarkStatuses").data("kendoMultiSelect");
                multiSelect.enable(enable);
                $('input[name=ActiveSwitch]').attr("disabled", !enable);
            }
        });

        $("#runUpdate").on('click', (e)=> {
            // require from data
            if ($("#FromData_tmkGlobalUpdate").data('kendoComboBox').value() === "") {
                alert('Please enter the data you want to update.');
                return;
            }

            // don't allow if update sets tmkstatus to null
            const updateField = this.getUpdateField();
            if ($("#ToData_tmkGlobalUpdate").data('kendoComboBox').value() === "" &&
                ("TrademarkStatus".search(updateField) > -1)) {
                alert(`You cannot remove: ${updateField}`);
                return;
            }

            if (!confirm("This action will update the records using the criteria you entered.\nAre you sure you want to do this?"))
                return;

            const param = this.getCriteria();
            const selectedIds = this.getSelection();

            if (selectedIds.length > 0) {
                param.KeyIds = selectedIds;
                $.ajax({
                    url: this.controllerUrl + "TmkGlobalUpdate/RunUpdate",
                    data: param,
                    type: "POST",
                    success: (data) => {
                        alert("Records updated: " + data);
                        this.refreshLog = true;
                        this.criteriaUpdated = true; //force refresh on preview list
                        this.refreshUpdatePreview();
                    },
                    error: function (e) {
                        pageHelper.showErrors(e);
                    }
                });
            }
            
        });

        const previewContainer = $("#updatePreviewContainer");
        const previewContainerGrid = previewContainer.find("#previewListView");

        previewContainerGrid.on("change", "input[type='checkbox']", function () {
            self.pageSelection(this, this.checked);
        });

        previewContainer.on("change", "input[type='checkbox'].page-update", function () {
            const pageSelection = this.checked;
            previewContainerGrid.find("input[type='checkbox']").each(function () {
                self.pageSelection(this, pageSelection);
                $(this).prop("checked", pageSelection);
            });
        });

        self.checkUpdatedCriteria();
    }

    pageSelection = (checkbox, selection) => {
        const previewContainer = $("#updatePreviewContainer");
        const previewContainerGrid = previewContainer.find("#previewListView");
        const resultGrid = previewContainerGrid.data("kendoListView");
        const data = resultGrid.dataSource.data();
        const id = $(checkbox).data("id");
        if (id) {
            const item = data.find(e => e.KeyId == id); //diff data type
            if (item) {
                item.Selected = selection;
            }
        }
    }

    getSelection = () => {
        const previewContainer = $("#updatePreviewContainer");
        const previewContainerGrid = previewContainer.find("#previewListView");
        const resultGrid = previewContainerGrid.data("kendoListView");
        const selected = resultGrid.dataSource.data().filter(r => r.Selected).map(s => s.KeyId);
        return selected;
    }

    updateLogDataBound(e) {        
        const data = e.sender.dataSource.data();

        if (data.length > 0) {
            const listView = e.sender.element;

            //Weird issue with rendering page on different browsers/computers
            //Set delay to ensure the tag exists before run textOverflow()
            setTimeout(
                function () {
                    //collapsible container
                    $.each(listView.find(".globalUpdate-collapsible"), function () {
                        $(this).textOverflow();
                    });
                }, 150);
        }
    }

    checkUpdatedCriteria = () => {
        const self = this;
        const container = $("#updateCriteriaForm");

        container.on("input", "input, textarea", () => {
            self.criteriaUpdated = true;
        });

        //for checkboxes on ie/edge
        container.on("change", "input[type='checkbox']", () => {
            self.criteriaUpdated = true;
        });

        container.find(".k-combobox > input").each(function () {
            const comboBox = $(this).data("kendoComboBox");
            if (comboBox) {
                comboBox.bind("change", () => {
                    self.criteriaUpdated = true;
                });
            }
        });

        container.find(".k-dropdown > input").each(function () {
            const dropdownList = $(this).data("kendoDropDownList");
            if (dropdownList) {
                dropdownList.bind("change", () => {
                    self.criteriaUpdated = true;
                });
            }
        });

        container.find(".k-datepicker input").each(function () {
            const datePicker = $(this).data("kendoDatePicker");
            if (datePicker) {
                datePicker.bind("change", () => {
                    self.criteriaUpdated = true;
                });
            }
        });

        container.find(".k-datetimepicker input").each(function () {
            const dateTimePicker = $(this).data("kendoDateTimePicker");
            if (dateTimePicker) {
                dateTimePicker.bind("change", () => {
                    self.criteriaUpdated = true;
                });
            }
        });

        container.find(".k-numerictextbox input").each(function () {
            const numericTextBox = $(this).data("kendoNumericTextBox");
            if (numericTextBox) {
                numericTextBox.bind("spin", () => {
                    self.criteriaUpdated = true;
                });
            }
        });

        container.find(".k-editable-area > textarea").each(function () {
            var editor = $(this).data("kendoEditor");
            if (editor) {
                $(editor.body).bind("input", () => {
                    self.criteriaUpdated = true;
                });
                $(editor.body).bind("keyup", (e) => {
                    //delete key
                    if (e.keyCode === 46) {
                        self.criteriaUpdated = true;
                    }
                });
            }
        });
        container.on("click", ".k-clear-value", () => {
            self.criteriaUpdated = true;
        });
    }
}


